/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const KeyNotEqualLabelKeyLabelValue: core.serialization.ObjectSchema<
    serializers.KeyNotEqualLabelKeyLabelValue.Raw,
    Truvity.KeyNotEqualLabelKeyLabelValue
> = core.serialization.object({
    key: core.serialization.string(),
    value: core.serialization.string(),
});

export declare namespace KeyNotEqualLabelKeyLabelValue {
    export interface Raw {
        key: string;
        value: string;
    }
}
